import React from "react";
import PropTypes from "prop-types";
import { Button, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import ClosedIcon from "Assets/Icons/ClosedIcon";

function AndroidPWAPrompt(props: any) {
  const { modalOpen, setModalOpen, installLater, installApp } = props;
  return (
    <>
      <ModalHeader>
        <div className="closedIcon">
          <ClosedIcon onClick={() => setModalOpen(!modalOpen)} />
        </div>
        <div className="installModalHeader">
          Install AakashGuru on your mobile!
        </div>
      </ModalHeader>
      <ModalBody className="installModalBody">
        Seamlessly check student performances, schedules, syllabus, test/lecture
        planners, lecture PPTs, batches, and more.
      </ModalBody>
      <ModalFooter className="d-flex justify-content-between">
        <div onClick={installLater} className="stayDiv">
          Stay on web
        </div>
        <Button size="sm" className="installAppBtn" onClick={installApp}>
          Install App
        </Button>
      </ModalFooter>
    </>
  );
}

AndroidPWAPrompt.propTypes = {
  modalOpen: PropTypes.bool,
  installApp: PropTypes.func,
  setModalOpen: PropTypes.func,
  installLater: PropTypes.func,
};
export default AndroidPWAPrompt;
